export default __webpack_public_path__ + "assets/kenya-flag.png";